export default "__VITE_ASSET__DYotv75$__"